<!-- EXT-6537: the condensed "blue box" account bar. Every line is one line
     tall and ends in an ellipsis, so the bar stays two lines with the drawer
     open or closed. EXT-6573: with no account it is a gray bar holding only
     the account lookup. -->
@if (displayBar() && platformAccount(); as account) {
  <button
    type="button"
    class="details"
    [class.active]="activeTab() === 'account'"
    [attr.aria-pressed]="activeTab() === 'account'"
    title="Open the account drawer"
    (click)="showDrawer('account')"
  >
    <span class="col col-store">
      <strong class="line store-name"
        >{{ account.accountNumber }} · {{ account.accountName }}</strong
      >
      <span class="line">
        {{ addressLine() }}
        @if (phone(); as accountPhone) {
          · {{ accountPhone | phone }}
        }
      </span>
    </span>

    <span class="col">
      <span class="line"
        ><span class="label">Whse</span>&nbsp;<strong>{{
          account.serviceCenter || "—"
        }}</strong></span
      >
      <span class="line"
        ><span class="label">COD</span>&nbsp;<strong>{{
          account.codCode || "—"
        }}</strong></span
      >
    </span>

    <span class="col">
      <span class="line"
        ><span class="label">Owner</span>&nbsp;<strong>{{
          account.ownerName || "—"
        }}</strong></span
      >
      <span class="line"
        ><span class="label">Mgr</span>&nbsp;<strong>{{
          account.managerName || "—"
        }}</strong></span
      >
    </span>

    <span class="col">
      <span class="line"
        ><span class="label">MDM</span>&nbsp;<strong>{{ mdm() }}</strong></span
      >
      <span class="line"
        ><span class="label">Est.</span>&nbsp;<strong>{{
          established()
        }}</strong></span
      >
    </span>

    <span class="col col-tags">
      @if (eliteLabel(); as elite) {
        <span class="tag tag-elite" title="Elite status">{{ elite }}</span>
      }
      @if (ecomLabel(); as ecom) {
        <span class="tag tag-ecom" title="Ecom status">{{ ecom }}</span>
      }
    </span>
  </button>

  <!-- EXT-6573: one chevron right after the account details opens and closes
       the drawer, replacing the Shipping and Comments buttons. -->
  <button
    type="button"
    class="drawer-toggle"
    [attr.aria-expanded]="drawerOpen()"
    [attr.aria-label]="
      drawerOpen() ? 'Close the account drawer' : 'Open the account drawer'
    "
    [title]="
      drawerOpen() ? 'Close the account drawer' : 'Open the account drawer'
    "
    (click)="toggleDrawer()"
  >
    <mat-icon aria-hidden="true">chevron_right</mat-icon>
  </button>
}
@if (displayBar()) {
  <!-- EXT-6573: Account # · Caller · GO (app-account-setter, projected by
       app.component) at the right end of the bar, with or without an account. -->
  <div class="lookup-slot">
    <ng-content></ng-content>
  </div>
}
